window._ = require('lodash');
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

    require('datatables.net-bs4');
    require('datatables.net-autofill-bs4');
    require('datatables.net-buttons-bs4');
    //require('datatables.net-buttons/js/dataTables.buttons');
    require('datatables.net-buttons/js/buttons.colVis');
    require('datatables.net-buttons/js/buttons.flash');
    require('datatables.net-buttons/js/buttons.html5');
    require('datatables.net-buttons/js/buttons.print');
    require('datatables.net-colreorder-bs4');
    require('datatables.net-datetime');
    require('datatables.net-editor-bs4');
    require('datatables.net-fixedcolumns-bs4');
    require('datatables.net-fixedheader-bs4');
    require('datatables.net-keytable-bs4');
    require('datatables.net-responsive-bs4');
    require('datatables.net-rowgroup-bs4');
    require('datatables.net-rowreorder-bs4');
    require('datatables.net-scroller-bs4');
    require('datatables.net-searchbuilder-bs4');
    require('datatables.net-searchpanes-bs4');
    require('datatables.net-select-bs4');
    require('datatables.net-staterestore-bs4');
    require('select2/dist/js/select2.full.min');
    //require('select2/dist/js/i18n/af.js');
    //require('select2/dist/js/i18n/ar.js');
    //require('select2/dist/js/i18n/it.js');
    //require('./datatables.net-editor/editor.autoComplete.js');
    //require('./datatables.net-editor/editor.bootstrapDate.js');
    //require('./datatables.net-editor/editor.chosen.js');
    //require('./datatables.net-editor/editor.ckeditor4.js');
    //require('./datatables.net-editor/editor.ckeditor5.js');
    //require('./datatables.net-editor/editor.datetimepicker.js');
    //require('./datatables.net-editor/editor.datetimepicker-2.js');
    //require('./datatables.net-editor/editor.display.js');
    //require('./datatables.net-editor/editor.mask.js');
    //require('./datatables.net-editor/editor.qr.js');
    //require('./datatables.net-editor/editor.quill.js');
    require('./datatables.net-editor/editor.select2.js');
    //require('./datatables.net-editor/editor.selectize.js');
    //require('./datatables.net-editor/editor.tinymce.js');
    //require('./datatables.net-editor/editor.title.js');*/
} catch (e) {}

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});
